import { compose, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import IeltsReview from "./IeltsReview";
import { getStudentTestScoresAction } from "../../../api/jsonapi";
import { ieltsModalVisibleSelector, getApplicationIeltsScores, getStudentPersonalInformation } from "../../../store/selectors/ielts_modal";
import { ieltsModalHideAction, ieltsModalShowAction } from "../../../store/actions/ielts_modal";
import enhancer from "./enhancer";
import componentErrorBoundary from "../../enhancers/componentErrorBoundary";
import lazyLoad from "../../enhancers/lazyLoad";
export default compose(componentErrorBoundary, connect(function (state) {
  return {
    application_ielts_scores: getApplicationIeltsScores(state),
    personal_information: getStudentPersonalInformation(state),
    isOpen: ieltsModalVisibleSelector(state)
  };
}, function (dispatch) {
  return {
    onRequestClose: function onRequestClose() {
      return dispatch(ieltsModalHideAction());
    },
    onRequestOpen: function onRequestOpen() {
      return dispatch(ieltsModalShowAction());
    }
  };
}), lazyLoad('api_student_test_scores', getStudentTestScoresAction, function (perform, _ref) {
  var student_information_id = _ref.student_information_id;
  return perform({
    id: student_information_id
  });
}, function (_ref2) {
  var request = _ref2.request;
  return !request.hasStarted;
}), withPropsOnChange(['status'], function (_ref3) {
  var _status$api_student_t;
  var status = _ref3.status;
  return {
    formLoading: status === null || status === void 0 ? void 0 : (_status$api_student_t = status.api_student_test_scores) === null || _status$api_student_t === void 0 ? void 0 : _status$api_student_t.isLoading
  };
}), enhancer)(IeltsReview);